import { useContext } from 'react';
import { useAppSelector } from 'redux/hooks';

import { useSelectedMaterial } from '@ee-api/materials-api/useSelectedMaterial';
import { useSelectedStore } from '@ee-api/stores-api/useSelectedStore';
import { DrawingShapeContext } from '@ee-context';
import { selectZipcode } from '@redux/slices/zipcodeSlice';

export const useAreSinksAvailable = (): { areSinksAvailable: boolean } => {
    const zipcode = useAppSelector(selectZipcode);
    const { areThereShapesInTheDrawingArea } = useContext(DrawingShapeContext);
    const { selectedValue: selectedStore } = useSelectedStore();
    const { selectedValue: selectedMaterial } = useSelectedMaterial();

    return {
        areSinksAvailable: !!zipcode && !!selectedStore && !!selectedMaterial && !!areThereShapesInTheDrawingArea,
    };
};
